import { render } from "./AccessDenied.vue?vue&type=template&id=15ea7285&scoped=true"
const script = {}

import "./AccessDenied.vue?vue&type=style&index=0&id=15ea7285&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/cdas-intranet-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ea7285"]])

export default __exports__